/** Locked design width — layout inside the iframe always sees this width. */
export const DESIGN_WIDTH = 1920;

/**
 * Extra default zoom above fit-to-width, in percent (Chrome-style).
 * 0  → 100% (exact fit to DESIGN_WIDTH)
 * 20 → 120% (20% zoomed in)  ← current default
 * -10 → 90% (zoomed out)
 * Change this number to tune the default.
 */
export const DEFAULT_ZOOM_PERCENT = 0;

/** Query flag that marks the document as the in-iframe app (not the outer shell). */
export const VIEWPORT_QUERY_PARAM = "__bs_viewport";
export const VIEWPORT_QUERY_VALUE = "1";
